export interface BannerDto
{
    getId(): number;
    getImgPath(): string;
    getBannerOrder(): string;
    getType(): string;
    getLanguage(): string;
    getSearchKey() : string;
}

export class BannerDtoImpl implements BannerDto
{
    private id: number;
    private imgPath: string;
    private type: string;
    private language: string;
    private searchKey: string;
    private bannerOrder: string;

    setId(id: number)
    {
        this.id = id;
    }

    getId(): number {
        return this.id;
    }

    getBannerOrder(): string
    {
        return this.bannerOrder;
    }
    setBannerOrder(bannerOrder: string)
    {
        this.bannerOrder = bannerOrder;
    }

    setImgPath(imgPath: string)
    {
        this.imgPath = imgPath;
    } 

    getImgPath(): string 
    {
        return this.imgPath;
    }
    
    setType(type: string)
    {
        this.type = type;
    }
    getType(): string 
    {
        return this.type;
    }   

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }   

    getSearchKey(): string
    {
        return this.searchKey;
    }
    setSearchKey(searchKey: string)
    {
        this.searchKey = searchKey;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/banner/bannerdto.ts